const ALLOWED_TAGS = new Set([
  'br',
  'div',
  'p',
  'figure',
  'img',
  'ul',
  'ol',
  'li',
  'strong',
  'em',
  'b',
  'i',
  'u',
  'span',
  'blockquote',
  'a',
]);

const removeNodeKeepChildren = (element: Element) => {
  const parent = element.parentNode;
  if (!parent) return;
  while (element.firstChild) {
    parent.insertBefore(element.firstChild, element);
  }
  parent.removeChild(element);
};

const sanitizeAllowedAttributes = (element: Element) => {
  const tag = element.tagName.toLowerCase();
  const attrs = Array.from(element.attributes);

  attrs.forEach(({ name }) => {
    const attr = name.toLowerCase();
    const isAllowedImageAttr =
      tag === 'img' && (attr === 'src' || attr === 'alt' || attr === 'data-embed');
    const isAllowedFigureAttr =
      tag === 'figure' && (attr === 'data-embed' || attr === 'contenteditable');
    const isAllowedLinkAttr =
      tag === 'a' && (attr === 'href' || attr === 'target' || attr === 'rel');

    if (!isAllowedImageAttr && !isAllowedFigureAttr && !isAllowedLinkAttr) {
      element.removeAttribute(name);
    }
  });
};

export const sanitizeProjectDescHtml = (html: string): string => {
  if (!html) return html;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  doc.querySelectorAll('script, style, iframe, object, embed, link, meta').forEach((node) => node.remove());

  Array.from(doc.body.querySelectorAll('*')).forEach((element) => {
    const tag = element.tagName.toLowerCase();
    if (!ALLOWED_TAGS.has(tag)) {
      removeNodeKeepChildren(element);
      return;
    }
    sanitizeAllowedAttributes(element);
  });

  return doc.body.innerHTML;
};
